

































import { Mixins, Component } from "vue-property-decorator"
import PageMixin from "@/mixins/page"
import PageHeader from "@/components/page-header/index.vue"
import { pick } from "lodash"
import { PRODUCT_STATUS } from "../product/constant"
import { getColumns } from "./constant"
import manageService from "@/services/manage.service"
import { mapGetters } from "vuex"

@Component({
    name: "AigcList",
    components: {
        PageHeader
    },
    computed: {
        ...mapGetters("common", [
            "product_type",
            "product_sub_type",
            "corporation",
            "top_dept",
            "visible_products",
            "business_area",
            "software_list",
            "visible_products"
        ])
    }
})
export default class AigcList extends Mixins(PageMixin) {
    readonly categories: any
    readonly top_dept: any
    readonly product_sub_type: any
    readonly software_list: any
    readonly visible_products: any
    readonly business_area: any

    loading = false

    addLoading = false
    exportLoading = false

    tableData: any[] = []
    searchParams = {
        keyword: "" as string,
        pagination: { current: 0, pageSize: 10 },
        sorts: [] as any[],
        filters: [] as any[]
    }
    isActive = true
    activated() {
        this.isActive = true
        this.onSearch(
            this.searchParams.keyword,
            this.searchParams.pagination,
            this.searchParams.sorts,
            this.searchParams.filters
        )
    }

    deactivated() {
        this.isActive = false
    }
    get columns() {
        return getColumns(this)
    }

    get tableActions() {
        return (record: any) => {
            const actions = {
                edit: {
                    title: "编辑",
                    event: "edit"
                },

                up: {
                    title: "上架",
                    event: "up",
                    need_confirm: true,
                    confirm_content: (h: any, record: any) => {
                        return h("span", null, `确定上架 "${record.title}" 吗？`)
                    },
                    style: {
                        color: "#00A854"
                    }
                },
                offShelf: {
                    title: "下架",
                    event: "offShelf",
                    need_confirm: true,
                    confirm_content: (h: any, record: any) => {
                        return h("span", null, `确定下架 "${record.title}" 吗？`)
                    },
                    style: {
                        color: "red"
                    }
                }
            }

            let actionKeys: (keyof typeof actions)[] = []
            if (record.status === PRODUCT_STATUS.待上架) {
                actionKeys = ["edit", "up", "offShelf"]
            } else if (record.status === PRODUCT_STATUS.正常) {
                actionKeys = ["edit", "offShelf"]
            } else if (record.status === PRODUCT_STATUS.下架) {
                actionKeys = ["edit", "up"]
            }
            const filteredActions = pick(actions, actionKeys)
            return Object.values(filteredActions)
        }
    }

    async onOffShelf(record: any) {
        await manageService.aigcDown({ id: record[0].id })
        this.$message.success("下架成功")
        this.manualSearch()
    }

    async onUp(record: any) {
        await manageService.aigcUp({ id: record[0].id })
        this.$message.success("上架成功")
        this.manualSearch()
    }

    onEdit(record: any[]) {
        this.$router.push({
            path: "/manage/aigc-edit",
            query: {
                id: record[0].id,
                from_type: "edit"
            }
        })
    }

    onView(record: any[]) {
        this.$router.push({
            path: "/manage/aigc-detail",
            query: {
                id: record[0].id
            }
        })
    }

    onAdd() {
        this.$router.push({
            path: "/manage/aigc-add",
            query: {
                from_type: "add"
            }
        })
    }
    handleExport() {
        this.exportLoading = true

        // 复用参数处理逻辑，但使用正确的分页计算
        const { pagination } = this.searchParams
        const query: any = {}
        this.searchParams.filters.forEach(item => {
            query[item.dataIndex] = item.keyword
        })
        const { product_name, ...restQuery } = query
        // 使用正确的分页计算逻辑，与 onSearch 保持一致
        const offset = (pagination.current - 1) * pagination.pageSize
        const payload = {
            offset,
            limit: pagination.pageSize,
            product_id: product_name,
            ...restQuery
        }

        manageService
            .exportAigcList(payload)
            .then(() => {
                this.$message.success("导出成功")
            })
            .catch(err => {
                this.$message.error(`导出失败：${err}`)
            })
            .finally(() => {
                this.exportLoading = false
            })
    }
    async onSearch(
        keyword: string,
        pagination: any,
        sorts: any[],
        filters: any[]
    ): Promise<{ total: number; list: any[] }> {
        Object.assign(this.searchParams, { keyword, pagination, sorts, filters })
        const { offset, limit } = pagination
        const query: any = {}
        this.searchParams.filters.forEach(item => {
            query[item.dataIndex] = item.keyword
        })
        const { product_name, ...restQuery } = query
        const payload = {
            offset,
            limit,
            product_id: product_name,
            ...restQuery
        }
        this.loading = true
        try {
            const res: any = await manageService.aigcList(payload)
            const { list, total } = res || {}
            this.tableData = list || []
            this.pagination.total = total
            return {
                list,
                total
            }
        } catch (error) {
            if (error) {
                this.$message.error(`获取数据失败！ ${error}`)
            }
        } finally {
            this.loading = false
        }
    }
}
